import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';
import './styles/App.css';

// Add Vidstack v1.x styles
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';


// Find the root element
const rootElement = document.getElementById('root');
// Create a root
const root = ReactDOM.createRoot(rootElement);

// Initial render: Render the App component to the root
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);